






import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { Route } from "vue-router";

@Component
export default class Splash extends Vue {
  @Getter("loaded") loaded!: boolean;

  mounted() {
    const loaded = true;
    this.$store.commit("setLoaded", { loaded });
    const from = this.$route.query.redirect as string;

    Promise.all([
      this.axios
        .get("/api/departments")
        .then(({ data }) => {
          this.$store.commit("setDepartmentsData", {
            departments: data.departments,
          });
        })
        .catch((error) => console.log(error)),
      this.axios
        .get("/api/users/me")
        .then(({ data }) => {
          this.$store.commit("auth/setUserData", { user: data.user });
        })
        .catch((error) => console.log(error)),
      new Promise((resolve) => setTimeout(resolve, 1000)),
    ])
      .then(() => {
        this.$router.replace(from);
      })
      .catch(() => {
        this.$router.replace(from);
      });
  }
}
